import { PRODUCT_SERVICE, PRODUCT_PRODUCT } from '@/utils/types/product'

const productTypeMixin = {
  methods: {
    itemIsProduct (item) {
      return item.type === PRODUCT_PRODUCT
    },
    itemIsService (item) {
      return item.type === PRODUCT_SERVICE
    }
  }
}

export default productTypeMixin



// WEBPACK FOOTER //
// ./src/utils/mixins/productTypeMixin.js